import React from 'react';
import PropTypes from 'prop-types';
import {
  TickSvg,
  SilhouetteAvatar,
  SilhouetteAvatarWithAFriend,
  Pencil,
  ClockSvg,
  Briefcase,
  CompletedCircle,
  CanceledCircle,
} from 'AppSrc/core/components/common/svg-icons';
import { CRQ_STATUSES } from 'AppSrc/core/crq/crq-statuses';
import { COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { FIXED } from 'AppSrc/core/components/forms/value-dependency-constants';
import { WorkFlowStage } from './workflow-stage';
import { ChangeAssigneeModal } from './change-assignee-modal';
import 'AppSrc/core/style/components/view-crq-screen/workflow-bar.css';


class WorkflowBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editingAssignee: null,
      editingName: '',
      // circuitChangeAnalystName: '',
    };
    this.editAssignee = this.editAssignee.bind(this);
    this.closeChangeAssigneeModal = this.closeChangeAssigneeModal.bind(this);
  }

  getFirstNameLastName(circuitChangeAnalyst) {
    const splitValue = circuitChangeAnalyst && circuitChangeAnalyst.split('@');
    const firstLast = splitValue && splitValue[0];
    const modifiedName = firstLast && firstLast.replace(/\.|[0-9]/g, ' ');
    return modifiedName;
  }

  editAssignee(params) {

    const {
      statusId,
      editingName,
    } = params;

    this.setState({
      editingAssignee: statusId,
      editingName,
    });
  }

  closeChangeAssigneeModal() {
    this.setState({
      editingAssignee: null,
    });
  }


  // static getDerivedStateFromProps(nextProps, prevState) {
  //   // do things with nextProps.someProp and prevState.cachedSomeProp
  //   console.log('nextProps.circuitChangeAnalyst', nextProps.circuitChangeAnalyst);
  //   const splitValue = nextProps.circuitChangeAnalyst  && nextProps.circuitChangeAnalyst.split("@");
  //   const firstLast = splitValue && splitValue.split(".");
  //   console.log('splitValue', splitValue, firstLast);
  //   return {
  //     circuitChangeAnalystName: nextProps.circuitChangeAnalyst,
  //     // ... other derived state properties
  //   };
  // }


  render() {
    const {
      submitted,
      coordinator,
      peerReview,
      circuitCheck,
      approvals,
      scheduled,
      implementation,
      completed,
      closed,
      cancelled,
    } = CRQ_STATUSES;

    const stususesThatHideWorkflowBar = [
      cancelled,
    ];

    const workflowStages = [
      {
        statusId: submitted,
        header: 'Submitted',
        svgIcon: TickSvg,
      },
      {
        statusId: coordinator,
        header: 'Coordinator',
        svgIcon: SilhouetteAvatar,
      },
      {
        statusId: peerReview,
        header: 'Peer Review',
        svgIcon: SilhouetteAvatarWithAFriend,
      },
      {
        statusId: approvals,
        header: 'Approvals',
        svgIcon: Pencil,
      },
      {
        statusId: scheduled,
        header: 'Scheduled',
        svgIcon: ClockSvg,
      },
      {
        statusId: implementation,
        header: 'Implementation',
        svgIcon: Briefcase,
      },
      {
        statusId: completed,
        header: 'Completed',
        svgIcon: CompletedCircle,
      },
      {
        statusId: closed,
        header: 'Closed',
        svgIcon: CanceledCircle,
      },
    ];
    const {
      statusReason,
      impactValue,
      network,
      // circuitChangeAnalyst,
      // assign,
      changeAnalystCircuitCheckID, // adding for displaying name
      // userLoggedIn, // adding for displaying name
      otherLineOperator,
      slaType,
      isIcmCrq,
    } = this.props;
    if ((impactValue === '1' || impactValue === '2') && network === FIXED && otherLineOperator !== 'Yes') {
      workflowStages.splice(3, 0, {
        statusId: circuitCheck,
        header: 'Circuit Check',
        svgIcon: SilhouetteAvatar,
      });
    }

    const circuitCheckAnalystName = this.getFirstNameLastName(changeAnalystCircuitCheckID);
    // finds where in the crq workflow the current CRQ is;
    const getStatusIndex = (status) => {
      const statusIndex = workflowStages.findIndex((workflowItem) => workflowItem.statusId === status);
      // if statusIndex isn't found, it returns -1;
      if (statusIndex < 0) {
        console.error(`Unable to find statusIndex for status: ${status}`);
        // if it all goes wrong, we fall back and just say the crq is on the first step
        return 0;
      }
      return statusIndex;
    };


    const getUserNameForStatusId = (names, statusId) => {
      const {
        coordinatorName,
        peerReviewerName,
        requesterName,
      } = names;

      const statusIdToName = {
        [submitted]: requesterName,
        [coordinator]: coordinatorName,
        [peerReview]: peerReviewerName,
        [circuitCheck]: circuitCheckAnalystName,
        [approvals]: null,
        [scheduled]: null,
        [implementation]: null,
        [completed]: null,
        [closed]: null,
        [circuitCheck]: null,
      };
      if (!statusIdToName.hasOwnProperty(statusId)) {
        console.error(`cannot find name for statusId: ${statusId} in getUserNameForStatusId`);
        return null;
      }
      const name = statusIdToName[statusId] || null;

      return name;
    };

    // FN: 30/04/2020
    // check if the user can edit the actor assigned to this step from thw work flow.
    // The logic for this boils down to:
    // "Is the CRQ in the correct state (isCorrectState)"
    // and
    // "Is the user the correct person to edit it (isCorrectPerson)"
    const getCanEdit = (params) => {
      const {
        status,
        statusId,
        userRole,
        coordinatorId,
        peerReviewerId,
        remedyId,
      } = params;

      // info about the CRQs state
      const isInCoordinatorReviewStatus = status === coordinator;
      const isInPeerReviewStatus = status === peerReview;

      // info about the person
      const isCoordinator = userRole === COORDINATOR;
      const isAssignedCoordinator = isCoordinator && (remedyId === coordinatorId);
      const isAssignedPeerReviewer = isCoordinator && (remedyId === peerReviewerId);

      /*
        Change Coordinator:
          isCorrectState:
            -Always
          isCorrectPerson:
            -Any coordinator
      */
      if (statusId === coordinator) {
        const isCorrectState = true;
        const isCorrectPerson = isCoordinator;
        const canEdit = (isCorrectState && isCorrectPerson);
        return canEdit;
      }


      /*
        Change Peer Reviewer:
          isCorrectState:
            -The CRQ is in Peer Review Status
            -The CRQ is in Coordinator Review Status and has a Peer Reviewer assigned
          isCorrectPerson:
            -Any Cooridnator or Peer Reviewer assigned to the CRQ
      */
      if (statusId === peerReview) {
        const canEditFromCoordinatorReviewStatus = peerReviewerId ? true : false;
        const isInCoordinatorReviewStatusWithAPeerReviewId = (isInCoordinatorReviewStatus && canEditFromCoordinatorReviewStatus);

        const isCorrectState = isInPeerReviewStatus || isInCoordinatorReviewStatusWithAPeerReviewId;
        const isCorrectPerson = isAssignedCoordinator || isAssignedPeerReviewer;
        const canEdit = (isCorrectState && isCorrectPerson);
        return canEdit;
      }

      return false;
    };

    const getStepVisited = ({
      statusId,
      rejectedFromPeer,
    }) => {
      if (statusId === peerReview) {
        return rejectedFromPeer;
      }
      return false;
    };
    const {
      status,
      coordinatorName,
      peerReviewerName,
      requesterName,
      userRole,
      crqId,
      coordinatorId,
      peerReviewerId,
      remedyId,
      rejectedFromPeer,
      requester,
      coordinatorGroup, // added on 10th oct for coordinator group
    } = this.props;
    const {
      editingAssignee,
      editingName,
    } = this.state;

    if (stususesThatHideWorkflowBar.includes(status)) {
      // For example, we don't show the workflow bar for cancelled
      return null;
    }

    const statusIndex = getStatusIndex(status);
    // the names to display for each section
    // if no name is sent by SIT but an ID is available, display that instead
    const names = {
      coordinatorName: coordinatorName ? `${coordinatorGroup} ${coordinatorName}` : `${coordinatorGroup} ${coordinatorId}`, // added on 10th oct for coordinator group
      peerReviewerName: peerReviewerName || peerReviewerId,
      requesterName: requesterName || requester,
    };


    return (
      <div className="crq-summary-workflow-bar">
        <div className="connecting-rod-container">
          <div className="connecting-rod" />
        </div>
        <ul className="workflow-stages">
          {
            workflowStages.map((workflowStageComponentData, stepIndex) => {
              // know render the stages in order and we know where the current stage is in that
              // order from statusIndex
              let stepComplete;
              let isCurrentStep;
              if (statusReason === '10500' && status === '4' && network === FIXED) {
                stepComplete = stepIndex < statusIndex + 1;
                isCurrentStep = stepIndex - 1 === statusIndex;
              }
              else {
                stepComplete = stepIndex < statusIndex;
                isCurrentStep = stepIndex === statusIndex;
              }
              const statusId = workflowStageComponentData.statusId;
              // Emergency changes for Peer to L3 name change
              if (statusId === peerReview) {
                if ((slaType === '2000' || slaType === 'Emergency') && otherLineOperator !== 'Yes') {
                  workflowStageComponentData.header = 'L3 Review';
                }
              }
              let name = getUserNameForStatusId(names, statusId);
              if (statusId === circuitCheck) {
                name = circuitCheckAnalystName;
              }
              const canEdit = getCanEdit({
                status, // the status the CRQ is in
                statusId, // the status in the workflow bar
                userRole,
                coordinatorId,
                peerReviewerId,
                remedyId,
              });
              // some steps, such as peer review, can be visited but not completed
              // for example if a CRQ is in coordinator review, after rejection from
              // peer review, peer review has been visited
              const stepVisited = getStepVisited({
                statusId,
                rejectedFromPeer,
              });
              return (
                <WorkFlowStage
                  key={statusId}
                  workflowStageComponentData={workflowStageComponentData}
                  stepComplete={stepComplete}
                  isCurrentStep={isCurrentStep}
                  name={name}
                  canEdit={canEdit}
                  stepVisited={stepVisited}
                  editAssignee={this.editAssignee}
                />
              );
            })
          }
        </ul>
        {
          editingAssignee && (
            <ChangeAssigneeModal
              editingType={editingAssignee}
              network={network}
              crqId={crqId}
              slaType={slaType}
              isIcmCrq={isIcmCrq}
              otherLineOperator={otherLineOperator}
              closeChangeAssigneeModal={this.closeChangeAssigneeModal}
              editingName={editingName}
            />
          )
        }
      </div>
    );
  }
}




WorkflowBar.propTypes = {
  status: PropTypes.string,
  coordinatorName: PropTypes.string,
  peerReviewerName: PropTypes.string,
  coordinatorGroup: PropTypes.string, // added on 10th oct for coordinator group
  requesterName: PropTypes.string,
  requester: PropTypes.string,
  userRole: PropTypes.string,
  network: PropTypes.string,
  crqId: PropTypes.string.isRequired,
  coordinatorId: PropTypes.string,
  peerReviewerId: PropTypes.string,
  remedyId: PropTypes.string,
  rejectedFromPeer: PropTypes.bool,
  statusReason: PropTypes.string,
  impactValue: PropTypes.string,
  // circuitChangeAnalyst: PropTypes.string,
  // assign: PropTypes.bool,
  // userLoggedIn: PropTypes.string,
  changeAnalystCircuitCheckID: PropTypes.string,
  otherLineOperator: PropTypes.string,
  slaType: PropTypes.string,
  isIcmCrq: PropTypes.bool,
};

export { WorkflowBar };

